var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMvBildzeichen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "76.45 0 36.85 31.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mecklenburg-Vorpommern") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#005e90;}.cls-2{fill:url(#Unbenannter_Verlauf_5);}.cls-3{fill:url(#Unbenannter_Verlauf_62);}.cls-4{fill:url(#Unbenannter_Verlauf_41);}.cls-5{fill:#f2b700;}.cls-6{fill:url(#Unbenannter_Verlauf_32);}.cls-7{fill:url(#Unbenannter_Verlauf_6);}.cls-8{fill:url(#Unbenannter_Verlauf_6-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_5",
    x1: 77.08391,
    y1: 22.21157,
    x2: 113.43772,
    y2: 30.60451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5e9841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4596,
    stopColor: "#679d48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6da14d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5e9841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_62",
    x1: 77.08391,
    y1: 22.21157,
    x2: 113.43772,
    y2: 30.60451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#289b38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36963,
    stopColor: "#319f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#3da54c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#289b38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_41",
    x1: 94.87943,
    y1: 13.29865,
    x2: 94.87943,
    y2: 24.93903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2676a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00529,
    stopColor: "#2576a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17354,
    stopColor: "#116897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33964,
    stopColor: "#046192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#005e90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_32",
    x1: 90.27939,
    y1: 14.03253,
    x2: 90.27939,
    y2: 0.00081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc6e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19323,
    stopColor: "#58bee5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73219,
    stopColor: "#21a8dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99375,
    stopColor: "#0ca0d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6",
    x1: 113.26653,
    y1: 13.74329,
    x2: 113.26653,
    y2: 13.73981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96c5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21183,
    stopColor: "#7fb9dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51882,
    stopColor: "#64aad5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79155,
    stopColor: "#54a1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e9ecf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6-2",
    x1: 112.71431,
    y1: 13.71899,
    x2: 112.71431,
    y2: 13.71558,
    xlinkHref: "#Unbenannter_Verlauf_6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bildzeichen_40",
    "data-name": "Bildzeichen 40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.9129,20.95462c-5.679.31559-12.82928,2.6454-17.21232,3.37a52.42079,52.42079,0,0,1-7.24636.61441v6.24207h36.85037V21.45885a47.93751,47.93751,0,0,0-8.41788-.61591C103.67309,20.84294,102.34472,20.87528,100.9129,20.95462Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.9129,20.95462c-5.679.31559-12.82928,2.6454-17.21232,3.37a52.42079,52.42079,0,0,1-7.24636.61441v6.24207h36.85037V21.45885a47.93751,47.93751,0,0,0-8.41788-.61591C103.67309,20.84294,102.34472,20.87528,100.9129,20.95462Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.87955,13.29865c-8.53535,0-18.42531.73388-18.42531.73388V24.939a52.41512,52.41512,0,0,0,7.24635-.61445c4.383-.72454,11.53325-3.05438,17.21228-3.37,1.43183-.07935,2.76024-.11169,3.97382-.11169a47.934,47.934,0,0,1,8.41792.616V13.74329S103.72831,13.29865,94.87955,13.29865Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.10456.00061a64.43537,64.43537,0,0,0-2.6283,9.25488,39.51381,39.51381,0,0,0-.687,4.10034c6.72951.11976,12.51539.38746,12.51539.38746V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.47625,9.25549a64.40366,64.40366,0,0,1,2.6283-9.25407L76.45424.00081V14.03253s9.88995-.73389,18.4253-.73389c1.97325,0,3.9783.02283,5.90967.05719A39.51043,39.51043,0,0,1,101.47625,9.25549Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M113.30461,13.74329l-.07617-.00348Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M112.75442,13.719l-.08022-.00341Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvBildzeichen);
export default __webpack_public_path__ + "static/media/mv-bildzeichen.91dd284e8ef20d10cdae35853b29077c.svg";
export { ForwardRef as ReactComponent };